import pulseTracker from '@finn-no/pulse-sdk';

const getListingType = (type) => {
    if (type === 'MESSAGING') return 'private';
    if (type === 'EMAIL') return 'professional';
    return 'n/a';
};

const createTrackingObject = (
    { intent, name },
    { adId, title, trackingCategory, type, vertical, trackingObjectName },
) => {
    const trackingObject = {
        type: 'Click',
        intent,
        name,
        object: {
            id: 'sendMessageButton',
            type: 'UIElement',
            elementType: 'Button',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: adId,
                    contentId: `${adId}`,
                    name: title,
                    category: trackingCategory,
                    listingType: getListingType(type),
                },
            ],
            page: {
                type: 'ClassifiedAd',
            },
        },
        target: {
            id: 'id',
            type: 'Message',
        },
        vertical: {
            name: vertical,
        },
    };

    if (trackingObjectName) {
        trackingObject.object.name = trackingObjectName;
    }

    return trackingObject;
};

function trackButtonClick(trackingData) {
    const trackingObject = createTrackingObject(
        { intent: 'Create', name: 'Send message' },
        trackingData,
    );
    pulseTracker.trackEvent(trackingObject);
}

function trackButtonClickUserMustVerify(trackingData) {
    const trackingObject = createTrackingObject(
        { intent: 'Attempt', name: 'eID - verification' },
        trackingData,
    );
    pulseTracker.trackEvent(trackingObject);
}

export { trackButtonClick, trackButtonClickUserMustVerify };
